module.exports = "/images/model_f8e9a3.png";